import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";

let deferred = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; });
}

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || navigator.standalone;

export const InstallAppButton = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const h = () => force((n) => n + 1);
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  if (standalone()) return null;
  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      deferred = null;
      force((n) => n + 1);
    } else if (isIos()) {
      toast.message("On iPhone: tap the Share icon in Safari, then “Add to Home Screen”.", { duration: 7000 });
    } else {
      toast.message("Open your browser menu and choose “Install app” or “Add to Home screen”.", { duration: 7000 });
    }
  };
  return (
    <button data-testid="install-app-button" onClick={install} className="shrink-0 h-10 px-4 rounded-full border border-primary/50 text-sm font-semibold inline-flex items-center gap-1.5 hover:bg-primary/10">
      <Download className="h-4 w-4" />Install app
    </button>
  );
};
